/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ScriptIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M5.5,17.5 L5.5,3.5 C5.5,1.843 6.843,0.5 8.5,0.5 L21,0.5" />
      <path d="M9,5.5 L14.5,5.5" />
      <path d="M9,8.5 L14.5,8.5" />
      <path d="M9,11.5 L14.5,11.5" />
      <path d="M9,14.5 L14.5,14.5" />
      <path d="M15.5,23.5 L3.5,23.5 C1.843,23.5 0.5,22.157 0.5,20.5 C0.5,18.843 1.843,17.5 3.5,17.5 L15.5,17.5 C13.843,17.5 12.5,18.843 12.5,20.5 C12.5,22.157 13.843,23.5 15.5,23.5 C17.156,23.5 18.5,22.157 18.5,20.5 L18.5,3 C18.5,1.619 19.618,0.5 21,0.5 C22.38,0.5 23.5,1.619 23.5,3.5 L18.5,3.5" />
    </g>
  </svg>
);

export default ScriptIcon;
